<div class="card visitor-card">
  <div class="card-header card-no-border pb-0">
    <div class="header-top">
      <h5 class="m-0">
        Visitors<span class="f-14 font-primary f-w-500 ms-1">
          <svg class="svg-fill me-1">
            <use href="assets/svg/icon-sprite.svg#user-visitor"></use></svg>{{ '(+2.8)' | translate }}</span>
      </h5>
      <div class="card-header-right-icon">
        <div class="dropdown icon-dropdown">
          <button class="btn dropdown-toggle" type="button" (click)="toggle()"><i class="icon-more-alt"></i></button>
          <div class="dropdown-menu dropdown-menu-end" [class.show]="show"><a class="dropdown-item" href="#">{{ 'Today' | translate }}</a><a class="dropdown-item" href="#">{{ 'Tomorrow' | translate }}</a><a class="dropdown-item" href="#">{{ 'Yesterday' | translate }}</a></div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body pt-3">
    <div class="visitors-container">
      <div id="visitor-chart">
        <apx-chart
          [series]="visitors.series"
          [chart]="visitors.chart"
          [plotOptions]="visitors.plotOptions"
          [dataLabels]="visitors.dataLabels"
          [stroke]="visitors.stroke"
          [grid]="visitors.grid"
          [colors]="visitors.colors"
          [xaxis]="visitors.xaxis"
          [yaxis]="visitors.yaxis"
          [fill]="visitors.fill"
          [legend]="visitors.legend"
          [responsive]="visitors.responsive"
        ></apx-chart>
      </div>
    </div>
  </div>
</div>
